import ProductList from './product-list';

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MenuEditor/components/ProductList/index.jsx